<template>
  <v-dialog :value="isShow" max-width="1000" persistent>
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-center font-weight-bold mb-5">
          Những học sinh có cùng SĐT sẽ được chuyển cùng một QLHT
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-simple-table class="table-layout pa-4 pt-0">
            <template>
              <thead>
              <tr class="grey lighten-1">
                <th class="text-left">SĐT</th>
                <th class="text-left">Học viên</th>
                <th class="text-left">QLHT xác nhận chuyển mới</th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(itemI, i) in studentDuoTheSameHomeroomTeacher">
                <template v-for="(itemJ, j) in itemI.std">
                  <tr :key="itemJ.id">
                    <td v-if="j === 0" :rowspan="itemI.std.length">{{ itemI.mobile }}</td>
                    <td :class="itemJ.is_same ? 'is-same-contact-color text-left' : 'text-left'">{{ itemJ.full_name }} {{ itemJ.is_same ? ' - cùng SĐT' : '' }}</td>
                    <td v-if="i === 0 && j === 0" :rowspan="rowSpanGvcn">{{ gvcn.name }}</td>
                  </tr>
                </template>
              </template>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-actions
          class="px-0 px-4 w-full"
        >
          <div class="content-confirm-change-teacher">Bạn có muốn đổi Quản lý lớp ?</div>
          <div class="d-flex justify-space-between" style="width: 27%;float:right">
            <v-btn class="cancel-button" @click="hideModal">Hủy bỏ</v-btn>
            <v-spacer />
            <v-btn class="update-button" @click.prevent="handleSubmit(saveChange)"
              >Xác nhận</v-btn
            >
          </div>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    studentDuoTheSameHomeroomTeacher: {
      type: Array,
      default: () => [],
    },
    gvcn: {
      type: Object,
      default: () => {},
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    rowSpanGvcn: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      errorMessage: '',
      sale: {},
    };
  },
  created() {},
  methods: {
    hideModal() {
      Bus.$emit('close-modal-confirm-change-homeroom-teacher', false);
      this.errorMessage = '';
    },
    async saveChange() {
      Bus.$emit('update-gvcn');
    },
  },
};
</script>
<style scoped>
thead tr th, tbody tr td {
  border: 1px solid #eee9e9;
  text-align: center !important;
  font-size: 14px !important;
}
.group-btn--form {
  float: right;
  margin-right: 20px;
  max-width: unset;
}
.is-same-contact-color {
  color: #374aa3;
}
.update-button {
  background-color: #fd1f6d !important;
  color: white;
}
.cancel-button {
  background: #bdbdbd !important;
  color: white;
}
.content-confirm-change-teacher {
  color: #333;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 133.333% */
}
</style>
